/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {RepeatableUserModelScreensManager} from '../../../../../components/sections/repeatable/repeatable-user-model-screens-manager.service';
import {RepeatableScreensManagerDeps} from '../../../../shared/step/repeatable-screen-manager.class';
import {AbmsBoardService} from '../../../../../domain/model/licenses-certifications/board/abms/abms-board.service';
import {Observable} from 'rxjs';

@Injectable()
export class AbmsBoardScreensManager extends RepeatableUserModelScreensManager {

    constructor(rsmm: RepeatableScreensManagerDeps, protected readonly _modelService: AbmsBoardService) {
        super(rsmm);
    }

    navigateToPreviousScreenFrom(index: number): Observable<boolean> {
        this.itemIndex = index;
        return this.navigateToPreviousScreen();
    }

    navigateToNextScreenFrom(index: number): Observable<boolean> {
        this.itemIndex = index;
        return this.navigateToNextScreen();
    }

    navigateToScreen(index: number): Observable<boolean> { return this._navigate(index); }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/board/abms/abms-board-screens-manager.service.ts